import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Team from '../components/Team';

const TeamPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <main className="pt-20">
        <Team />
      </main>
      <Footer />
    </div>
  );
};

export default TeamPage;
